import { isValidElement } from 'react'
import apiConfig from '../apiConfig'
import Cookies from 'js-cookie'
import ReactImageMagnify from 'react-image-magnify'
import queryString from 'query-string'
import { isEmpty, flatten } from 'lodash'
import moment from 'moment'
import momentBusinessDays from 'moment-business-days'
import defaultThumbnail from '../images/defaultThumbnail.jpg'
import Paper from '@material-ui/core/Paper'
import ThumbnailBlock from 'components/Search/ThumbnailBlock'
import { PROPS, SAMPLE, SCENIC } from 'enums/Tabs'
import { SampleStatus } from 'enums/sampleStatus'
export const sampleFieldLabelMapper = () => {
  return {
    pegasusId: 'pegasus_id',
    orderNum: 'order_num',
    sample_status: 'sample_status',
    tcin: 'tcin',
    dpci: 'dpci',
    userId: 'user_id',
    vendorId: 'vendor_id',
    vendorEmail: 'vendor_email_id',
    shipTo: 'ship_to_loc',
    dueDate: 'sample_due_date',
    brand: 'brand',
    vendorNotes: 'vendor_notes',
    studioNotes: 'studio_notes',
    shipmentId: 'shipment_id',
    createDate: 'create_ts',
    sampleLaunchDate: 'launch_date',
    location: 'location',
    receivedDate: 'received_date',
    dispositionNotes: 'disposition_notes',
    warehouseNotes: 'warehouse_notes',
    digital_markdown_date: 'digital_markdown_date',
    store_markdown_date: 'store_markdown_date',
    disposition_date: 'disposition_date',
    disposition_override_date: 'disposition_override_date',
    isOwnedBrand: 'is_owned_brand',
    propCategory: 'category',
  }
}
export const CustomPaper = (props) => {
  return <Paper elevation={8} {...props} />
}
export const editableFieldsMapper = () => {
  return {
    vendorNotes: 'vendor_notes',
    studioNotes: 'studio_notes',
    dispositionNotes: 'disposition_notes',
    warehouseNotes: 'warehouse_notes',
    disposition_override_date: 'disposition_override_date',
    propCategory: 'propCategory',
    propSubcategory: 'propSubcategory',
    propColorFamily: 'propColorFamily',
    propMaterial: 'propMaterial',
    propSource: 'propSource',
  }
}

export function getKeyByValue(object = {}, value) {
  return Object.keys(object).find((key) => object[key] === value)
}

export function getUserName(userInfo = {}) {
  const { firstName = '', lastName = '', fullName = '' } = userInfo
  const userName =
    [firstName, lastName].filter((obj) => obj).join('.') || fullName || ''
  return userName
}

export const getDisplayImage = (imageUrl = '', height = '80', width = '80') => {
  return !isEmpty(imageUrl) ? (
    <div>
      <img
        height={height}
        width={width}
        style={{ objectFit: 'contain' }}
        src={imageUrl}
        alt="Not Found"
      />
    </div>
  ) : (
    'Image not found'
  )
}
export const getDisplayImageWithProps = (
  imageUrl = '',
  height = 80,
  width = 80
) => {
  return !isEmpty(imageUrl) ? (
    <div>
      <img
        style={{ height, width, objectFit: 'contain' }}
        src={imageUrl}
        alt="Not Found"
      />
    </div>
  ) : (
    'Image not found'
  )
}
export const getDisplayImageList = (imageUrl = []) => {
  const imageListDiv = imageUrl.length
    ? imageUrl?.map((currentImage) => {
        return currentImage?.image_url ? (
          <div>
            <img
              height={80}
              style={{ objectFit: 'contain' }}
              src={currentImage?.image_url}
              alt="Not Found"
            />
          </div>
        ) : (
          ''
        )
      })
    : ''
  return imageListDiv
}

export const getDisplayThumbnailList = (imageUrl = []) => {
  const imageListDiv = imageUrl?.map((currentImage) => {
    return currentImage?.image_url ? (
      <div>
        <ThumbnailBlock
          imgSrc={currentImage?.image_url}
          enablePreview={true}
          val={currentImage?.image_url}
          previewHandler={() => {
            currentImage?.image_url &&
              window.open(currentImage?.image_url, '_blank')
            return false
          }}
          previewType={'view'}
        />
      </div>
    ) : (
      'Image not found'
    )
  })
  return <>{imageListDiv}</>
}
export const getImageMagnifier = (imageUrl = '') => {
  const bigImageQueryParts = {
    wid: 1000,
    hei: 1000,
    make_square: true,
  }
  const bigImageQuery = `${imageUrl}?${queryString.stringify(
    bigImageQueryParts
  )}`
  const imageQueryParts = {
    wid: 200,
    hei: 200,
    make_square: true,
  }
  const imageQuery = `${imageUrl}?${queryString.stringify(imageQueryParts)}`
  return !isEmpty(imageUrl) ? (
    <ReactImageMagnify
      smallImage={{
        isFluidWidth: true,
        alt: 'Not Found',
        src: imageQuery,
      }}
      largeImage={{
        alt: 'Not Found',
        src: bigImageQuery,
        width: 1000,
        height: 1000,
      }}
      enlargedImagePosition="over"
      enlargedImageContainerDimensions={310}
    />
  ) : (
    <img
      height={200}
      width={200}
      src={imageUrl}
      style={{ objectFit: 'contain' }}
      alt="Not Found"
      onError={(e) => {
        e.target.src = defaultThumbnail
      }}
    />
  )
}
export const PGPREFIX = 'PG'
export const WHPREFIX = 'WH'
export const PPPREFIX = 'PP'
export const PSPREFIX = 'PS'
export const DATE_FORMAT = 'MMM D, YYYY'
export const PAYLOAD_DATE_FORMAT = 'YYYY-MM-DD'
export const CSV_DATE_FORMAT = 'MM/DD/YYYY'
export const normalizeSizeValues = (sizeValue = []) => {
  if (Array.isArray(sizeValue)) {
    return sizeValue
      .flatMap((value) => {
        if (typeof value === 'string') {
          return value.split(',')
        }

        if (value && typeof value === 'object' && value.name) {
          return value.name
        }

        return []
      })
      .map((value) => String(value || '').trim())
      .filter(Boolean)
  }

  if (typeof sizeValue === 'string') {
    return sizeValue
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean)
  }

  return []
}

export const isDateInPast = (inputDate) => {
  if (inputDate) {
    // Create a date object...
    const dateToCompare = moment(inputDate)
    // Date object for today
    var today = moment().startOf('day') // At midnight earlier today
    return dateToCompare < today
  }
  return false
}
export const convertTableDateFormat = (inputDate = '', dateformat = '') => {
  const returnValue =
    !isEmpty(inputDate) && inputDate !== '0001-01-01'
      ? moment(inputDate).format(dateformat)
      : ''
  return returnValue
}

export const getSampleIDPrefix = (sampleid = '', type = SAMPLE) => {
  if (!sampleid) {
    return ''
  }
  if (type === PROPS) {
    return PPPREFIX + sampleid
  } else if (type === SCENIC) {
    return PSPREFIX + sampleid
  }
  return sampleid?.toString().length === 7
    ? WHPREFIX + sampleid
    : PGPREFIX + sampleid
}

export const getSampleIDWithouPrefix = (pegasusId = '') => {
  return pegasusId && Number(pegasusId.slice(2, pegasusId.length))
}

/**
 * Check for invalid prefix for Props and Samples type
 * @param {String} pegasusId
 * @param {String} type
 * @returns
 */
export const doesPegasusIdPrefixMatchType = (pegasusId = '', type = SAMPLE) => {
  const prefix = pegasusId && pegasusId.slice(0, 2)
  let isValidPrefix = true

  if (
    (type === SAMPLE && [PPPREFIX, PSPREFIX].includes(prefix)) ||
    (type === PROPS && [WHPREFIX, PGPREFIX, PSPREFIX].includes(prefix)) ||
    (type === SCENIC && [WHPREFIX, PGPREFIX, PPPREFIX].includes(prefix))
  ) {
    isValidPrefix = false
  }
  return isValidPrefix
}

export const getInvalidPegasusIdListBasedOnPrefixAndType = (
  pegasusIdList = [],
  type = SAMPLE
) => {
  const validPegasusIds = pegasusIdList.filter(
    (pegasusId) => !doesPegasusIdPrefixMatchType(pegasusId, type)
  )
  return validPegasusIds
}

export const getDomainName = (hostName) => {
  return hostName.substring(
    hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1
  )
}

export const defaultDueDateColumns = [
  'Royalston',
  'Schawk',
  'Periscope',
  'Splashlight',
]

export const shipToOnChange = (
  shipTo = '',
  tcin = '',
  dueDate = '',
  launchDate = '',
  days = 40
) => {
  let defaultDueDate = null
  const todayDate = new Date()
  defaultDueDateColumns.map((obj) => {
    if ((shipTo || '').indexOf(obj) !== -1 && !isEmpty(launchDate)) {
      const curLaunchDate = new Date(launchDate)
      defaultDueDate = momentBusinessDays(launchDate)
        .businessSubtract(days)
        .toDate()
      if (todayDate > defaultDueDate || curLaunchDate < todayDate) {
        defaultDueDate = null
      }
      defaultDueDate = moment(defaultDueDate)
    }
    return obj
  })
  return defaultDueDate
}

export const getFromBrowserStorage = function (storageKey = '') {
  return window.localStorage.getItem(storageKey)
}

export const setInBrowserStorage = function (
  storageKey = '',
  storageValue = ''
) {
  window.localStorage.setItem(storageKey, storageValue)
}

export const removeFromBrowserStorage = function (storageKey = '') {
  return window.localStorage.removeItem(storageKey)
}

export const sortByDate = function (
  myArray = [],
  myOrderBy = '',
  myOrder = 'desc'
) {
  if (myArray === null || myArray.length === 0) {
    return []
  }
  const orderedArray =
    myOrder === 'desc'
      ? myArray.sort(function (a, b) {
          let nameA = new Date(a[myOrderBy]).getTime()
          let nameB = new Date(b[myOrderBy]).getTime()
          return nameB < nameA ? -1 : 1
        })
      : myArray.sort(function (a, b) {
          let nameA = new Date(a[myOrderBy]).getTime()
          let nameB = new Date(b[myOrderBy]).getTime()
          return nameA < nameB ? -1 : 1
        })
  return orderedArray
}

export const sortingOrder = (varA, varB) => {
  let comparison = 0
  if (varA && varB) {
    if (varA === varB) {
      comparison = 0
    } else {
      varA > varB ? (comparison = -1) : (comparison = 1)
    }
  } else if (varA === null) {
    comparison = 1
  } else if (varB === null) {
    comparison = -1
  }
  return comparison
}

export const dateSortingOrder = (varA, varB) => {
  let comparison = 0
  if (varA && varB) {
    if (varA === varB) {
      comparison = 0
    } else {
      varA > varB ? (comparison = 1) : (comparison = -1)
    }
  } else if (varA === null || isNaN(varA)) {
    comparison = 1
  } else if (varB === null || isNaN(varB)) {
    comparison = -1
  }
  return comparison
}

export const SortAlphaNum = (order, orderBy) => {
  return function (a, b) {
    let comparison = 0
    if (a[orderBy] && b[orderBy]) {
      const reA = /[^0-9a-zA-Z]/g //any character otherthan uppercase letter (A-Z), a lowercase letter (a-z)
      const reN = /[^0-9]/g
      const aA = a[orderBy].replace(reA, '')
      const bA = b[orderBy].replace(reA, '')
      if (aA === bA) {
        const aN = parseInt(a[orderBy].replace(reN, ''), 10)
        const bN = parseInt(b[orderBy].replace(reN, ''), 10)
        aN === bN
          ? (comparison = 0)
          : aN > bN
            ? (comparison = 1)
            : (comparison = -1)
      } else {
        aA > bA ? (comparison = 1) : (comparison = -1)
      }
    } else if (a[orderBy] === null || a[orderBy] === '') {
      comparison = 1
    } else if (b[orderBy] === null || b[orderBy] === '') {
      comparison = -1
    }
    return order === 'desc' ? comparison * -1 : comparison
  }
}

function compareValues(key, order = 'asc') {
  return function (a, b) {
    if (!a.sortLocation[key] && !b.sortLocation[key]) {
      return 0
    }
    if (!a.sortLocation[key]) {
      return order === 'asc' ? -1 : 1
    }
    if (!b.sortLocation[key]) {
      return order === 'asc' ? 1 : -1
    }

    const varA =
      typeof a.sortLocation[key] === 'string'
        ? a.sortLocation[key].toUpperCase()
        : a.sortLocation[key]
    const varB =
      typeof b.sortLocation[key] === 'string'
        ? b.sortLocation[key].toUpperCase()
        : b.sortLocation[key]

    let comparison = varA.localeCompare(varB, undefined, {
      numeric: true,
      sensitivity: 'base',
    })

    return order === 'desc' ? comparison * -1 : comparison
  }
}

export const sortDataByPegLoc = (order = 'asc') => {
  const keys = ['building', 'aisle', 'section', 'shelf', 'container']
  return function (a, b) {
    let result
    for (let i = 0; i < keys.length; i += 1) {
      result = compareValues(keys[i], order)(a, b)
      if (result !== 0) {
        return result
      }
    }
    return 0
  }
}

export const getFormattedOptions = (optionsList = [], optionProps = {}) => {
  const { label: optionPropsLabel = '', value: optionsPropsValue = '' } =
    optionProps
  // Removing null fileds
  const filteredOptionsList = optionsList.filter((obj) => obj)

  const formattedOptions = filteredOptionsList.map((obj) => {
    switch (optionPropsLabel) {
      case 'class_id': {
        return {
          label: `${obj['department_id']}-${obj[optionPropsLabel]}`,
          value: `${obj['department_id']}-${obj[optionPropsLabel]}`,
          displayName: obj[optionsPropsValue]
            ? `${obj[optionPropsLabel]} - ${obj[optionsPropsValue] || ''}`
            : `${obj[optionPropsLabel]}`,
          group_by: obj['department_name']
            ? `${obj['department_id']} - ${obj['department_name']}`
            : `${obj['department_id']}`,
          group_by_id: obj['department_id'],
          id: `${obj['department_id']}-${obj[optionPropsLabel]}`,
        }
      }
      case 'department_id': {
        return {
          label: isNaN(obj[optionPropsLabel])
            ? obj[optionPropsLabel] || obj
            : obj[optionPropsLabel],
          value: isNaN(obj[optionPropsLabel])
            ? obj[optionsPropsValue] || obj
            : obj[optionsPropsValue],
          displayName: obj[optionsPropsValue]
            ? `${obj[optionPropsLabel]} - ${obj[optionsPropsValue] || ''}`
            : `${obj[optionPropsLabel]}`,
          id: obj['org_department_id'],
        }
      }
      default: {
        return {
          label: isNaN(obj[optionPropsLabel])
            ? obj[optionPropsLabel] || obj
            : obj[optionPropsLabel],
          value: isNaN(obj[optionPropsLabel])
            ? obj[optionsPropsValue] || obj
            : obj[optionsPropsValue],
          displayName: `${obj[optionsPropsValue] || obj}`,
          id: isNaN(obj[optionPropsLabel])
            ? obj[optionsPropsValue] || obj
            : obj[optionsPropsValue],
        }
      }
    }
  })
  return formattedOptions
}

export const getSubCategories = (categories = [], category_id) => {
  let itemCatSubCatArr = (categories || []).map(
    (mObj) => mObj.subCategories || mObj.scenic_sub_categories
  )
  if (category_id) {
    itemCatSubCatArr = itemCatSubCatArr?.find(
      (fObj) => fObj.category_id === category_id
    )
  }
  const itemCatSubCatList = flatten(itemCatSubCatArr || [])?.map((sObj) => {
    const {
      category_id: categoryId = '',
      category_name: categoryName = '',
      name: subCategoryName = '',
      sub_category_id: subCategoryId = '',
    } = sObj
    return sObj
      ? {
          label: subCategoryName,
          id: subCategoryId,
          value: subCategoryId,
          displayName: subCategoryId,
          categoryId: categoryId || '',
          categoryName: categoryName || '',
        }
      : true
  })
  return itemCatSubCatList
}

export const OAUTH_PARTNERSONLINE_PERF_URL =
  'https://oauth.iam.perf.partnersonline.com'
export const PARTNERSONLINE_PERF_HOST = 'xycpeg.perf.partnersonline.com'

export const headerBatchScannerPages = [
  '/searchInventory',
  '/searchInventory/samples',
  '/searchInventory/PROPS',
  '/searchInventory/SCENIC',
  '/checkIn',
  '/moveSamples',
  '/shipSamples',
  '/shipSamplesList/create',
  '/shipSamplesList/:id/edit',
]

export const getLocationNames = (locations) => {
  const locationNames = locations.map((it) =>
    Object.assign(
      {},
      {
        label: it.building,
        value: it.locationId,
      }
    )
  )
  return locationNames.sort((a, b) => (a.label > b.label ? 1 : -1))
}
/**
 * Function to check for react elements in data and remove them to avoid data clone errors
 * @param {*} data
 * @returns
 */
export const removeReactElementsFromObject = (data, customKey = '') => {
  const updatedData = {}
  Object.keys(data).forEach((key) => {
    const dataInstance = data[key]
    if (
      dataInstance &&
      typeof dataInstance === 'object' &&
      !Array.isArray(dataInstance) &&
      !isValidElement(dataInstance)
    ) {
      // Recursively remove React elements from nested objects
      updatedData[key] = removeReactElementsFromObject(dataInstance, key)[key]
    } else if (
      key === 'classId' &&
      dataInstance !== null &&
      dataInstance !== undefined &&
      !isValidElement(dataInstance)
    ) {
      updatedData[key] = dataInstance
    } else if (
      key !== 'classId' &&
      !!dataInstance &&
      !isValidElement(dataInstance)
    ) {
      // NULL is valid react element hence first do null check
      updatedData[key] = dataInstance
    } else if (!!dataInstance && isValidElement(dataInstance) && customKey) {
      // If customKey is provided, assign the value to that key
      updatedData[customKey] = dataInstance?.props?.children || ''
    }
    // If it's a React element or null/undefined, it will be skipped
  })

  return updatedData
}

export const removeReactElements = (data) => {
  let result
  if (Array.isArray(data)) {
    result = data.map((instance) => removeReactElementsFromObject(instance))
  } else {
    result = removeReactElementsFromObject(data)
  }
  return result
}

export const checkIsEnabledRow = (valueToCheckAgainst, item) => {
  if (!valueToCheckAgainst) {
    return true
  }
  const { keyToCheckAgainst, value } = valueToCheckAgainst
  const isEnabled = item[keyToCheckAgainst]
    ? item[keyToCheckAgainst] === value
    : true
  return isEnabled
}

export const isNumber = (input) => /^-?\d+$/.test(input)

export const getPegasusID = (id = '') => {
  return isHavingPrefix(id) ? id.slice(2, id.length) : id
}

export const isHavingPrefix = (id = '') => {
  return ['WH', 'PP', 'PS', 'PG', 'PS'].includes(
    id.substring(0, 2)?.toUpperCase()
  )
}

/**
 * Get displayname from user object
 * @param userObj object with first_name and last_name
 * @returns a string displayname
 */
export const getDisplayName = (userObj = {}) => {
  const { first_name = '', last_name = '' } = userObj
  const projectCreator = [first_name, last_name]
    .filter(function (el) {
      return el
    })
    .join(' ')
  return projectCreator
}

//Bottom bar clear all button action types
export const CLEARALL_ACTIONS_BY_PAGE = {
  REST_ALL_SEARCHINVENTORY: 'searchInventory',
  REST_ALL_AUTOORDER: 'autoOrderSamples',
  REST_ALL_MANUALORDER: 'search',
  REST_ALL_MANAGELOCATIONS: 'manageLocations',
  REST_ALL_NEWSHIPMENT: 'newShipment',
  REST_ALL_COLLECTIONLIST: 'collections',
  REST_ALL_NEWSHOOTTYPE: 'newShootType',
  REST_ALL_SEARCHARCHIVEDSAMPLES: 'searchArchivedSamples',
  REST_ALL_REVIEWORDER: 'order',
  REST_ALL_MYORDER: 'myOrder',
  REST_ALL_SEARCHINVENTORY_SAMPLES: 'searchInventory',
  REST_ALL_SEARCHINVENTORY_PROPS: 'searchInventory',
  REST_ALL_SEARCHINVENTORY_SCENIC: 'searchInventory',
  REST_ALL_AUTO_ORDER_GRID_SAMPLES: 'autoOrderSamples',
}

/**
 * Method to mutates current page state on clear all action for the pages present in CLEARALL_ACTIONS_BY_PAGE
 * @param {*} appInitState - initial state of application store
 * @param {*} updatedState - present state of the application store
 * @param {*} actionType - current triggered actiontype
 * @returns mutated state of current page
 */

export const getCurrentPageNewState = (
  appInitState,
  updatedState,
  actionType
) => {
  const currentPage = CLEARALL_ACTIONS_BY_PAGE[actionType]
  let currentSelectedData = []
  let currentNumSelected = Number(0)
  let currentNumSelectedTab = {
    PROPS: 0,
    SAMPLES: 0,
    SCENIC: 0,
  }
  if (actionType && currentPage) {
    switch (actionType) {
      case 'REST_ALL_SEARCHINVENTORY_SAMPLES':
        currentSelectedData =
          updatedState[currentPage]?.selectedData?.filter(
            (obj) => obj?.itemType !== 'SAMPLE'
          ) || []
        currentNumSelected = currentSelectedData?.length || Number(0)
        currentNumSelectedTab = Object.assign(
          {},
          updatedState[currentPage]?.numSelectedTab,
          { SAMPLES: 0 }
        )

        break
      case 'REST_ALL_SEARCHINVENTORY_PROPS':
        currentSelectedData =
          updatedState[currentPage]?.selectedData?.filter(
            (obj) => obj?.itemType !== 'PROPS'
          ) || []
        currentNumSelected = currentSelectedData?.length || Number(0)
        currentNumSelectedTab = Object.assign(
          {},
          updatedState[currentPage]?.numSelectedTab,
          { PROPS: Number(0) }
        )

        break
      case 'REST_ALL_SEARCHINVENTORY_SCENIC':
        currentSelectedData =
          updatedState[currentPage]?.selectedData?.filter(
            (obj) => obj?.itemType !== 'SCENIC'
          ) || []
        currentNumSelected = currentSelectedData?.length || Number(0)
        currentNumSelectedTab = Object.assign(
          {},
          updatedState[currentPage]?.numSelectedTab,
          { SCENIC: Number(0) }
        )

        break
      default:
        currentSelectedData = appInitState[currentPage]?.selectedData || []
        currentNumSelected = appInitState[currentPage]?.numSelected || Number(0)
        currentNumSelectedTab = appInitState[currentPage]?.numSelectedTab || {}

        break
    }
    const currentPageState = {
      ...updatedState[currentPage],
      selectedData: currentSelectedData,
      numSelected: currentNumSelected,
    }
    const currentPageUpdatedState =
      actionType?.indexOf('SEARCHINVENTORY') !== -1
        ? Object.assign({}, currentPageState, {
            numSelectedTab: currentNumSelectedTab,
          })
        : currentPageState
    updatedState = {
      ...updatedState,
      [currentPage]: currentPageUpdatedState,
    }
  }
  return updatedState
}

export const isSessionActive = (props) => {
  const { auth } = props
  const { session = {} } = auth
  const { userInfo = {} } = session || {}
  const { lanId = '' } = userInfo || {}
  const domain = getDomainName(window.location.hostname)

  if (domain === 'partnersonline.com') {
    //Check Single Sign On only for POL
    const ssoSessionInfo = Cookies.get('SSOSESSIONINFO') //oAuth will set this cookie
    let logOutUrl = '/'

    if (ssoSessionInfo) {
      const ssoSessionObj = JSON.parse(window.atob(ssoSessionInfo)) //Decode session and parse to json object
      if (
        ssoSessionObj.user &&
        ssoSessionObj.login_status &&
        lanId &&
        ssoSessionObj.user === lanId
      ) {
        //Valid only when user mathces and login status is true
        return true
      }
    } else {
      const locationHref = window.location.href
      logOutUrl = encodeURI(
        apiConfig.auth.logoutUrl + '?TARGET=' + locationHref
      )
    }
    //Invalid case
    localStorage.removeItem('access_token') //Remove token from LS will trigger the login route
    localStorage.removeItem('id_token')

    // toast.info(' POL session logged out or company changed.')
    setTimeout(() => {
      if (logOutUrl) {
        window.location.replace(logOutUrl) //Redirect to home page to login again
      }
    }, 3000)
    return false
  }
  return true
}

export const sideNavMenuList = [
  {
    name: 'Home',
    path: '/',
    reload: false,
    iconName: 'HouseIcon',
    groups: [],
    adgroups: [
      ...(apiConfig?.roles?.search || []),
      ...(apiConfig?.roles?.helpvendor || []),
      ...(apiConfig?.roles?.props || []),
      ...(apiConfig?.roles?.scenic || []),
      ...(apiConfig?.roles?.checkIn || []),
    ],
  },
  {
    name: 'Search',
    path: '/searchInventory',
    reload: false,
    iconName: 'SearchIcon',
    groups: [],
    adgroups: apiConfig?.roles?.inventory,
  },
  {
    name: 'Settings',
    path: '/settings',
    reload: false,
    iconName: 'GearIcon',
    groups: [],
    adgroups: apiConfig?.roles?.setting,
  },
  {
    name: 'Scenic Rooms',
    path: '/scenicRooms',
    reload: false,
    iconName: 'WorkspaceIcon',
    groups: [],
    adgroups: apiConfig?.roles?.scenic,
  },
  {
    name: 'Projects',
    path: '/projects',
    reload: false,
    iconName: 'DatabaseCheckIcon',
    groups: [],
    adgroups: apiConfig?.roles?.projects,
  },
  {
    name: 'Collections',
    path: '/collections',
    reload: false,
    iconName: 'CollectionIcon',
    groups: [],
    adgroups: apiConfig?.roles?.projects,
  },
  {
    name: 'My Order History',
    path: '/myOrders',
    reload: false,
    iconName: 'HistoryIcon',
    groups: [],
    adgroups: apiConfig?.roles?.mySamples,
  },
  {
    name: 'Requested Samples',
    path: '/orderSummary',
    reload: false,
    iconName: 'DashboardIcon',
    groups: [],
    adgroups: apiConfig?.roles?.vendor,
  },
  {
    name: 'Sample History',
    path: '/shipmentSummary',
    reload: false,
    iconName: 'HistoryIcon',
    groups: [],
    adgroups: apiConfig?.roles?.vendor,
  },
  {
    name: 'Check-In Samples',
    path: '/checkIn',
    reload: false,
    iconName: 'ListCheckIcon',
    groups: [],
    adgroups: apiConfig?.roles?.checkIn,
  },
  {
    name: 'Move Samples',
    path: '/moveSamples',
    reload: false,
    iconName: 'FulfillmentIcon',
    groups: [],
    adgroups: apiConfig?.roles?.checkIn,
  },
  {
    name: 'Ship Samples',
    path: '/shipSamples',
    reload: false,
    iconName: 'ShipIcon',
    groups: [],
    adgroups: apiConfig?.roles?.shipSamples,
  },
  {
    name: 'Manage Locations',
    path: '/manageLocations',
    reload: false,
    iconName: 'BackroomLocationManagementIcon',
    groups: [],
    adgroups: apiConfig?.roles?.manageLocations,
  },
  {
    name: 'Archived Samples',
    path: '/SearchArchivedSamples',
    reload: false,
    iconName: 'ArchiveIcon',
    groups: [],
    adgroups: apiConfig?.roles?.inventory,
  },
  {
    name: 'Batch Scanner',
    path: '/batchScanner',
    reload: false,
    iconName: 'ScanIcon',
    groups: [],
    adgroups: [
      ...(apiConfig?.roles?.helpUsers || []),
      ...(apiConfig?.roles?.helpvendor || []),
      ...(apiConfig?.roles?.props || []),
    ],
  },
  {
    name: 'Help',
    path: '/help',
    reload: false,
    iconName: 'HelpIcon',
    groups: [],
    adgroups: [
      ...(apiConfig?.roles?.helpUsers || []),
      ...(apiConfig?.roles?.helpvendor || []),
    ],
  },
]

export const computeTcinCompletionFromApi = (tcinInfoArray, shotCount) => {
  const list = Array.isArray(tcinInfoArray) ? tcinInfoArray : []
  const total = list.length
  if (!total) return { percent: 0, done: 0, total: 0 }
  const done = list.filter((t) => {
    const img = t.image_information
    const hasMain = img?.main ? 1 : 0
    const altLen = Array.isArray(img?.alt) ? img.alt.length : 0
    const imageTotal = hasMain + altLen
    const assetHubImageCount = (() => {
      const ai = t?.item_info?.images
      return (ai?.main ? 1 : 0) + (Array.isArray(ai?.alt) ? ai.alt.length : 0)
    })()
    return isTcinComplete(t, shotCount, imageTotal, assetHubImageCount)
  }).length
  const percent = Math.round((done / total) * 100)
  return { percent, done, total }
}

export const normalize = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase()

const PEGASUS_EARLY_STATUSES = new Set([
  SampleStatus.RECEIVED,
  SampleStatus.HOLD,
  SampleStatus.SHOOT_SHIPPED,
  'SAMPLE_DISPOSED',
  'SAMPLE_ARCHIVED',
])

export const isPegasusTcinDone_old = (tcinEntry) => {
  const samples = tcinEntry?.sample_info ?? tcinEntry?.samples ?? []
  if (!samples.length) return false
  return samples.some((s) => {
    const st = normalize(s?.sample_status || s?.sampleStatus || s?.status)
    return st && PEGASUS_EARLY_STATUSES.has((st || '')?.toUpperCase())
  })
}

export const isPegasusTcinDone = (tcinEntry) => {
  const samples = tcinEntry?.sample_info ?? tcinEntry?.samples ?? []
  if (!samples.length) return false

  return samples.every((s) => {
    const st = normalize(s?.sample_status || s?.sampleStatus || s?.status)
    return !!st && PEGASUS_EARLY_STATUSES.has(st.toUpperCase())
  })
}

export const getPegasusEarlyStatusCount = (tcinEntry) => {
  const samples = tcinEntry?.sample_info ?? tcinEntry?.samples ?? []
  if (!samples.length) return 0
  return samples.filter((s) => {
    const st = normalize(s?.sample_status || s?.sampleStatus || s?.status)
    return st && PEGASUS_EARLY_STATUSES.has((st || '')?.toUpperCase())
  }).length
}

export const isPhotoBridgeTcinDone = (tcinEntry, shotCount, imageTotal) => {
  const imgInfo = tcinEntry?.image_information
  if (!imgInfo) return false
  const expected = shotCount || imageTotal || 0

  const images = []
  if (imgInfo.main) images.push(imgInfo.main)
  if (Array.isArray(imgInfo.alt)) images.push(...imgInfo.alt)
  const sentToPiplineImages = []
  images.map((img) => {
    if (img?.retouch?.sent_to_pipeline != null) {
      sentToPiplineImages.push(img)
    }
    return true
  })
  if (!images.length || !expected) return false
  if (expected === sentToPiplineImages.length) return true
  return images.every((img) => img?.retouch?.sent_to_pipeline != null)
}

export const isPipelineTcinDone = (tcinEntry, shotCount, imageTotal) => {
  const expected = shotCount || imageTotal || 0
  if (!expected) return false
  const imgInfo = tcinEntry?.image_information
  if (!imgInfo) return false

  let accepted = 0
  // Check main image
  if (imgInfo.main) {
    const status = normalize(imgInfo.main.retouch?.retouch_status ?? '')
    if (status === 'accepted by pipeline') accepted += 1
  }
  // Check every alt image
  const alts = Array.isArray(imgInfo.alt) ? imgInfo.alt : []
  for (const a of alts) {
    const status = normalize(a?.retouch?.retouch_status ?? '')
    if (status === 'accepted by pipeline') accepted += 1
  }

  return accepted >= expected
}

export const isAssetHubTcinDone = (tcinEntry, shotCount, imageTotal) => {
  const expected = shotCount || imageTotal || 0
  if (!expected) return false
  const images = tcinEntry?.item_info?.images
  if (!images) return false
  const hasMain = images.main ? 1 : 0
  const altLen = Array.isArray(images.alt) ? images.alt.length : 0
  const total = hasMain + altLen
  return total >= expected
}

export const isTcinComplete = (
  tcinEntry,
  shotCount,
  imageTotal,
  assetHubImageCount
) => {
  const expected = shotCount || imageTotal || 0
  const assetHubExpected = assetHubImageCount || expected
  const photoBridgeDone = isPhotoBridgeTcinDone(tcinEntry, expected)
  const pegasusDone = isPegasusTcinDone(tcinEntry)
  const assetHubDone = isAssetHubTcinDone(tcinEntry, assetHubExpected)
  const pipelineDone = isPipelineTcinDone(tcinEntry, expected)
  return pegasusDone && photoBridgeDone && pipelineDone && assetHubDone
}

export const formatDate = (dateTimeStamp) => {
  const options = { year: 'numeric', month: 'short', day: 'numeric' }
  return new Date(dateTimeStamp).getTime() > 0
    ? new Date(dateTimeStamp).toLocaleDateString('en-US', options)
    : '-'
}

export const parseDateOnly = (value) => {
  if (!value) return null
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate())
  }

  const s = String(value).trim()
  const m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})/.exec(s)
  if (m) {
    const year = Number(m[1])
    const month = Number(m[2])
    const day = Number(m[3])
    const d = new Date(year, month - 1, day)
    if (!Number.isNaN(d.getTime())) return d
  }

  const d = new Date(s)
  if (Number.isNaN(d.getTime())) return null
  return new Date(d.getFullYear(), d.getMonth(), d.getDate())
}
